import axios from "axios";
import * as config from "../../../app.config";
import { setHeaders } from "../../../utils/basic";
import { useMutation } from 'react-query';
import { useDispatch } from 'react-redux';
import { USER_MESSAGE } from "../../../actions/User";
import moment from "moment";
import * as awsConstants from "../../../components/constants/fileConstants";
import { FILES_S3 } from "../../../actions/Files";


const signUrl = async (variables) => {
    const { blob, partName, fileId, fileType } = variables;
    const headerConfig = setHeaders();

    const bucketName = fileType === awsConstants.ENDPOINTS.qlp ? config.ENDPOINTS.qlpbucket : fileType === awsConstants.ENDPOINTS.ddpcr ? config.ENDPOINTS.ddpcrbucket : "";

    const postData = {
        bucket_name: bucketName,
        region: "us-west-2",
        expiration: 3600,
        file_name: partName,
        endpoint_url: config.ENDPOINTS.uploadUrl,
        file_directory: `unprocessed/${fileId}`
    }
    const { data } = await axios
        .post(`${config.ENDPOINTS["datalake"]}/signUrl`, postData, {
            headers: headerConfig
        })

    let output = data;
    output.blob = blob;
    output.partName = partName;
    output.fileId = fileId;
    return output;
}


const useMutateSignUrl = () => {

    const dispatch = useDispatch();

    return useMutation(signUrl, {
        onSuccess: (data, variables) => {
            const { file, fileId } = variables;
            dispatch({
                type: FILES_S3, fileId,
                payload: file
            });
            // dispatch({
            //     type: USER_MESSAGE,
            //     msgType: "success",
            //     text: "Files Signed Successfully",
            //     key: moment().unix()
            // });
        },

        onError: (error) => {
            console.log(error.response, "error")
            dispatch({
                type: USER_MESSAGE,
                msgType: "error",
                text: "Files could not be signed",
                key: moment().unix()
            });
        }
    })
}

export default useMutateSignUrl;
